/*
 * ***********************************************************************
 * BOUNTEOUS CONFIDENTIAL
 * ___________________
 *
 * Copyright 2019 Bounteous.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property
 * of Bounteous and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Bounteous
 * and its suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Bounteous.
 * ***********************************************************************
 */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'related-articles';
const teaserName = 'article-teaser';

class RelatedPosts extends Component {

    /**
     * Update Descriptions to max characters
     */
    updateDescriptions() {
        const classScope = this;
        const cards = this.elements.teaserCards();

        [...cards].map((card) => {
            const descriptionEle = card.querySelector(`.${teaserName}__description`);
            const descriptionText = descriptionEle.innerText;
            if(!descriptionEle || !descriptionText) return false;
            if(descriptionText.length >= classScope.maxDescriptionLength) {
                descriptionEle.innerText = `${descriptionText.substr(0, classScope.maxDescriptionLength - 3)}...`;
            }
            return true;
        });
    }

    /**
     * Component Init
     */
    init() {
        // Set up Elements
        this.elements = {
            container: this.element.querySelector('.cmp-related-articles__posts'),
            teaserCards: () => this.element.getElementsByClassName(teaserName),
        };

        // Set up Data
        this.maxDescriptionLength = 88;

        // Fire Init Funcs
        this.updateDescriptions();
    }
}

registerComponent(`.${componentName}`, RelatedPosts);
